export default "/images/vendor/flag-icons/flags/1x1/kz.svg?ad106a7a2ba93dfe9ce0609ebbd712b9";